(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/retail-list/assets/javascripts/retail-list-item.js') >= 0) return;  svs.modules.push('/components/marketplace/retail-list/assets/javascripts/retail-list-item.js');

'use strict';

const _ReactRouterDOM = ReactRouterDOM,
  Link = _ReactRouterDOM.Link;
const GroupHeader = svs.components.marketplace.groupHeader.GroupHeader;
const roles = svs.components.marketplaceData.auth.roles;
const CoverImage = svs.components.marketplace.coverImage.CoverImage;
const _svs$ui = svs.ui,
  ReactIcon = _svs$ui.ReactIcon,
  Paper = _svs$ui.ReactPaper;
const _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef;
const _ReactRouterDOM2 = ReactRouterDOM,
  useHistory = _ReactRouterDOM2.useHistory;
const RetailListItem = _ref => {
  let team = _ref.team,
    children = _ref.children,
    linkTo = _ref.linkTo,
    unreadMessages = _ref.unreadMessages,
    className = _ref.className,
    maxGamesToDisplay = _ref.maxGamesToDisplay,
    onClick = _ref.onClick;
  const el = useRef();
  const history = useHistory();
  useEffect(() => {
    if (el.current) {
      let hasScrolled = false;
      svs.components.Storage.browser.get('lastClickedTeam', 'marketplace', data => {
        if (data !== null && data !== void 0 && data.groupId && data.groupId === team.id) {
          hasScrolled = true;
          el.current.scrollIntoView({
            behavior: 'instant',
            block: 'center'
          });
          svs.components.Storage.browser.set('lastClickedTeam', 'marketplace', null);
        }
      });
      if (!hasScrolled && history.location.state && history.location.state.scrollToGroup) {
        el.current.scrollIntoView({
          behavior: 'instant',
          block: 'center'
        });
        history.location.state.scrollToGroup = null;
      }
    }
  }, []);
  const rootClassName = ['retail-container'];
  if (className) {
    rootClassName.push(className);
  }
  const gamesAmount = team.gamesAmount;
  const overflownGamesCount = Math.max(0, gamesAmount - maxGamesToDisplay);
  const renderRetailLink = () => React.createElement(Link, {
    className: "qa-redirect-retail-button retail-info-container f-uppercase",
    onClick: onClick,
    to: linkTo
  }, overflownGamesCount > 0 && React.createElement("div", {
    className: "retail-list-info-text"
  }, "+", overflownGamesCount, ' ', "spel"), React.createElement("div", {
    className: "retail-list-info-link"
  }, React.createElement("span", {
    className: "margin-right-half"
  }, "Till butiken"), React.createElement(ReactIcon, {
    color: "fc-grey-500",
    icon: "menu-right",
    size: "100"
  })));
  const LinkWrapper = _ref2 => {
    let children = _ref2.children,
      label = _ref2.label;
    return linkTo || onClick ? React.createElement(Link, {
      "aria-label": label,
      className: "qa-redirect-retail-header",
      onClick: onClick,
      to: linkTo
    }, children) : children;
  };
  return React.createElement(Paper, {
    branding: "sport",
    className: rootClassName.join(' ')
  }, React.createElement("div", {
    className: "header-link-holder",
    ref: el
  }, React.createElement(LinkWrapper, {
    label: team.name
  }, React.createElement(GroupHeader, {
    className: "retail-list-heading",
    groupId: team.id || team.groupId,
    isCaptain: team.role === roles.ROLES.CAPTAIN,
    isInverted: true,
    isUnreadCountVisible: false,
    membersCount: team.membersCount,
    myRole: team.role,
    teamName: team.name,
    unreadMessages: unreadMessages
  }), React.createElement("div", {
    className: "retail-image-container"
  }, React.createElement(CoverImage, {
    image: team.coverImage
  })))), children, linkTo || onClick ? renderRetailLink() : null);
};
setGlobal('svs.components.marketplace.retailList.RetailListItem', RetailListItem);

 })(window);